/* eslint-disable */
export default {
  methods: {
    logErrorsAndExceptions(location, error) {
      if (this.$appInsights && this.$appInsights.trackException) {
        this.$appInsights.trackException({
          exception: error instanceof Error ? error : new Error(location),
          properties: error instanceof Error ? { message: error.message, stack: error.stack } : { ...error }
        });
      } else {
        console.error(location, ':', error);
      }
    },

    logInfoAndDebug(location, message) {
      if (this.$appInsights && this.$appInsights.trackEvent) {
        this.$appInsights.trackEvent({
          name: location,
          properties: { ...message }
        });
      } else {
        console.log(location, ':', message);
      }
    }
  }
};
